export const compress = () => (
  <path
    d="M4 14h6m0 0v6m0-6l-7 7m17-11h-6m0 0V4m0 6l7-7"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
